// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"index_colorPicker__1Dacn","colorBolck":"index_colorBolck__23ZwO","colorText":"index_colorText__1YxsD","colorBg":"index_colorBg__1O3jf"};